import { trace } from 'owa-trace';
import type { IEditor } from 'roosterjs-editor-types';

export default function removeHintNodeFromEditor(
    editor: IEditor | undefined,
    unwantedNode: HTMLElement | null
): void {
    if (editor && unwantedNode) {
        trace.info('[Sonora Plugin] Removing hint from editor.');
        editor.deleteNode(unwantedNode);
    }
}
